<template>
  <div class="create-edit">
    <div class="box">
      <div class="title">话术标题<span class="red">*</span></div>
      <van-field v-model="title" label="" placeholder="请输入" />
      <div class="title">话术内容<span class="red">*</span></div>
      <van-field
        v-model="content"
        rows="3"
        autosize
        label=""
        type="textarea"
        placeholder="请输入"
      />
    </div>
    <div class="btn-box">
      <div
        class="btn"
        :class="title && content ? 'submit' : ''"
        @click="creatSpeechBank"
      >
        确认话术
      </div>
    </div>
  </div>
</template>

<script>
import { addPersonalApi, updatePersonalApi } from "@/api/modules/speechbank";
import { Toast } from "vant";
import { pageClickEvent } from "@/utils/utils";

export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      title: "", // 话术标题
      content: "", // content
      page_url: window.location.href, // 页面链接
      page_id: window.location.pathname, // 页面唯一标识
    };
  },
  created() {
    if (this.$route.query.id) {
      const personalItem = JSON.parse(sessionStorage.getItem("personalItem"));
      this.title = personalItem.title;
      this.content = personalItem.content;
    }
  },
  methods: {
    // 创建话术
    async creatSpeechBank() {
      if (!this.title || !this.content) return;
      if (this.$route.query.id) {
        // 编辑
        const res = await updatePersonalApi({
          id: this.$route.query.id,
          title: this.title,
          content: this.content,
          userIds: [this.userInfo.userId],
        });
        if (res.code === 0) {
          // 埋点 个人话术编辑
          pageClickEvent({
            button_name: "个人话术编辑", // 按钮名称
            platform_id: this.$route.query.id, // 话术ID
            platform_name: this.title, // 话术名称
            platform_type: "个人", // 话术类型
            page_id: this.page_id, // 页面唯一标识
            page_url: this.page_url, // 页面链接
            page_name: "话术库", // 页面名
            tab_name: "话术", // tab名称
          });
          Toast.success("提交成功");
          sessionStorage.removeItem("personalItem");
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        }
      } else {
        // 新建
        const res = await addPersonalApi({
          title: this.title,
          content: this.content,
          userIds: [
            {
              id: this.userInfo.userId,
              label: this.userInfo.name,
            },
          ],
        });
        if (res.code === 0) {
          // 埋点 个人话术添加
          pageClickEvent({
            button_name: "个人话术添加", // 按钮名称
            platform_id: res.data, // 话术ID
            platform_name: this.title, // 话术名称
            platform_type: "个人", // 话术类型
            page_id: this.page_id, // 页面唯一标识
            page_url: this.page_url, // 页面链接
            page_name: "话术库", // 页面名
            tab_name: "话术", // tab名称
          });
          Toast.success("提交成功");
          setTimeout(() => {
            sessionStorage.setItem("speechActive", "person");
            this.$router.go(-1);
          }, 500);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.create-edit {
  padding: 10px 12px;
  .box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    padding: 15px;
    background-color: #fff;
    .title {
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      margin-bottom: 8px;
    }
    ::v-deep .van-field {
      width: 100%;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #f2f2f2;
      margin-bottom: 24px;
      &::after {
        display: none;
      }
      .van-field__control {
        max-height: 300px;
      }
    }
    .red {
      color: red;
    }
  }
  .btn-box {
    position: fixed;
    bottom: 45px;
    left: 0;
    width: 100%;
    padding: 0 15px;
    .btn {
      width: 100%;
      height: 42px;
      background: rgba(242, 97, 71, 0.3);
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
    }
    .submit {
      background: #f26147;
    }
  }
}
</style>
